import { Table, Tabs } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { PartnerContext } from "../PartnerOutlet";
import AxiosInstance from "../../../../AxiosInstance";
import { amountFormat } from "../../../../utils";
import styles from "../partnerDashboard.module.css";
import { NavLink, useParams } from "react-router-dom";
import dayjs from "dayjs";
export default function PartnerInvestorTableView() {
  const IStatus = {
    active: "DONE",
    progress: "PENDING,SENT,REJECTED,PAYMENT_PENDING,PAYMENT_DONE",
    matured: "DONE",
  };
  const partnerContext = useContext(PartnerContext);
  const [loading, setLoading] = useState(true);
  const [paginationMetaData, setPaginationMetaData] = useState({});
  const [status, setStatus] = useState(IStatus.active);
  var [dataSource, setDataSource] = useState([]);
  const [summaryData, setSummaryData] = useState({});
  const [earningsummaryData, setEarningSummaryData] = useState({});
  let { investorId } = useParams();

  const onChange = (key) => {
    let newStatus = "";
    let localIsMatured = false;
    switch (key) {
      case "1":
        newStatus = IStatus.active;
        break;
      case "2":
        newStatus = IStatus.progress;
        break;
      case "3":
        newStatus = IStatus.matured;
        localIsMatured = true;
        break;
      default:
        break;
    }

    // Update the status and fetch data with the new status
    setStatus(newStatus);
    getTableData(0, newStatus, localIsMatured);
    getSummaryData(newStatus, localIsMatured);
  };

  useEffect(() => {
    let ignore = false;

    if (!ignore) {
      console.log("first", investorId);
      getTableData(0);
      getSummaryData();
      getEarningSummaryData();
    }
    return () => {
      ignore = true;
    };
  }, []);
  const getTableData = async (
    skip,
    currentStatus = status,
    isMatured = false
  ) => {
    const url = `/partner/referral/${partnerContext.viewMode}/list?take=10&skip=${skip}&status=${currentStatus}&isMatured=${isMatured}`;
    try {
      const resp = await AxiosInstance().get(url);
      const { data } = resp;
      setDataSource(data.data);
      setPaginationMetaData(data.paginationMetaData);
      setLoading(false);
    } catch (err) {
      console.error(err);
    }
  };
  const getEarningSummaryData = async () => {
    // Calculate the first and last days of the current month
    const fromDate = dayjs().startOf("month").format("YYYY-MM-DD");
    const toDate = dayjs().endOf("month").format("YYYY-MM-DD");

    const url = `/partner/summary?fromDate=${fromDate}&toDate=${toDate}`;

    try {
      const response = await AxiosInstance().get(url);
      const { data } = response;
      setEarningSummaryData(data);
    } catch (err) {
      console.error("Error fetching summary data:", err);
    }
  };
  const getSummaryData = async (currentStatus = status, isMatured = false) => {
    const url = `/partner/referral/${partnerContext.viewMode}/summary?status=${currentStatus}&isMatured=${isMatured}`;
    AxiosInstance()
      .get(url)
      .then((resp) => {
        let { data } = resp;
        // setPolicies(data.data);
        setSummaryData(data);
      })
      .catch((err) => {});
  };

  const columns = [
    // {
    //   title: "Refer Date",
    //   dataIndex: "createdAt",
    //   key: "createdAt",
    //   render: (text, policy) => moment(policy.createdAt).format("DD/MM/YYYY"),
    // },
    {
      title: "Investor Name",
      dataIndex: "role",
      key: "role",
      align: "center",
      render: (text, policy) => (
        <NavLink to={`investor/${policy.investorId}`}>
          {policy["firstName"] + " " + policy["lastName"]}
        </NavLink>
      ),
    },
    {
      title: "No. of Policies",
      dataIndex: "totalPolicyCount",
      key: "totalPolicyCount",
      align: "center",
    },
    {
      title: "Total Inv. Amount",
      dataIndex: "totalInvestmentAmount",
      key: "totalInvestmentAmount",
      align: "right",
      render: (text, policy) => <>{text ? amountFormat(text) : "N/A"}</>,
    },
    {
      title: "Growth",
      dataIndex: "growthRatio",
      key: "growthRatio",
      align: "center",
      render: (text, policy) =>
        text ? parseFloat(text).toFixed(1) + " %" : "N/A",
    },
    {
      title: "Current Value",
      dataIndex: "totalCurrentSurrenderValue",
      key: "totalCurrentSurrenderValue",
      align: "right",
      render: (text, policy) => <>{text ? amountFormat(text) : "N/A"}</>,
    },
  ];
  const change = (data) => {
    getTableData((data - 1) * 10);
  };
  const items = [
    {
      key: "1",
      label: "Active Policy",
      children: (
        <Table
          bordered={true}
          scroll={{ x: 400 }}
          loading={loading}
          className="table"
          dataSource={[...dataSource]}
          columns={columns}
          pagination={{
            pageSize: 10,
            total: paginationMetaData.count,
            onChange: change,
          }}
        />
      ),
    },
    {
      key: "2",
      label: "In Progress Policy",
      children: (
        <Table
          bordered={true}
          scroll={{ x: 400 }}
          loading={loading}
          className="table"
          dataSource={[...dataSource]}
          columns={columns}
          pagination={{
            pageSize: 10,
            total: paginationMetaData.count,
            onChange: change,
          }}
        />
      ),
    },
    {
      key: "3",
      label: "Matured Policy",
      children: (
        <Table
          bordered={true}
          scroll={{ x: 400 }}
          loading={loading}
          className="table"
          dataSource={[...dataSource]}
          columns={columns}
          pagination={{
            pageSize: 10,
            total: paginationMetaData.count,
            onChange: change,
          }}
        />
      ),
    },
  ];
  return (
    <div className="">
      <div className="d-flex justify-content-center">
        {" "}
        <div
          className={`ph-summary  h-[200px] p-4 shadow ${styles["partner-summary-card"]}`}
        >
          {" "}
          <div className="row">
            {" "}
            <div className="col">
              Total Policies: {amountFormat(summaryData?.totalPolicyCount)}
            </div>
            <div className="col">
              Total Investors: {amountFormat(summaryData?.totalInvestor)}
            </div>
          </div>
          <div className="row mt-2">
            {" "}
            <div className="col">
              Total Growth Ratio:{" "}
              {parseFloat(summaryData?.totalGrowthRatio).toFixed(2)}
            </div>
            <div className="col">
              Total Fund Value:{" "}
              {amountFormat(summaryData?.totalCurrentSurrenderValue)}
            </div>
          </div>
          <div className="row mt-2">
            <div className="col">
              Total Investments:{" "}
              {amountFormat(summaryData?.totalInvestmentAmount)}
            </div>
            <div className="col">
              Incentive in Month: {amountFormat(earningsummaryData?.amount)}
            </div>
          </div>
        </div>
      </div>
      {/* <Table
        bordered={true}
        scroll={{ x: 400 }}
        loading={loading}
        className="table"
        dataSource={[...dataSource]}
        columns={columns}
        pagination={{
          pageSize: 10,
          total: paginationMetaData.count,
          onChange: change,
        }}
      /> */}
      <Tabs defaultActiveKey="1" items={items} onChange={onChange} />
    </div>
  );
}
